export type StyleMixins = {
  adHeight: number
  adWidth: number
}

export const styleMixins: Record<string, StyleMixins> = {
  304_300: {
    adHeight: 304,
    adWidth: 300,
  },
  304_612: {
    adHeight: 304,
    adWidth: 612,
  },
  600_300: {
    adHeight: 600,
    adWidth: 300,
  },
}
